export default {
      id: "upload_small-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#upload_small",
      toString: function () {
        return this.url;
      }
    }